/** Render-relevant user fields — excludes volatile typing_at/typing_in */
export interface RenderUser {
  id: string;
  display_name: string;
  avatar_url?: string | null;
  is_coworker?: boolean | null;
  is_deactivated?: boolean | null;
  status_emoji?: string | null;
  /** Used to show the verified-team badge when the email ends with
   *  `@ano.dev`. Replaces the status emoji next to the display name. */
  email?: string | null;
}

/** True when the user is on the Ano team (verified badge in chat). */
export function isAnoTeamMember(user: { email?: string | null }): boolean {
  const email = user.email?.toLowerCase().trim();
  return !!email && email.endsWith("@ano.dev");
}
